import React from 'react';
import { Control, Controller, FieldErrorsImpl } from 'react-hook-form';
import { Typography } from '@navi/web-ui/lib/primitives';
import ErrorIconOutline from '@cp/src/assets/icons/ErrorIconOutline';
import Dropdown from '@cp/src/components/Dropdown';
import RequiredIcon from '@navi/web-ui/lib/icons/RequiredIcon';
import { AgentFormValues } from '../../interfaces/types';
import { IOption } from '@cp/src/components/FilterDrawer/types';
import { GenericObject } from '@cp/src/types/CommonConstans';

type AgentFormMultiSelectDropdownProps = {
  control: Control<AgentFormValues, GenericObject>;
  name: keyof AgentFormValues;
  errors: Partial<FieldErrorsImpl<AgentFormValues>>;
  isEditDisabled: boolean | undefined;
  styles: CSSModuleClasses;
  inputLabel: string;
  placeholder: string;
  options: IOption[];
  validationMessage?: string;
  showRequiredIcon?: boolean;
};

const AgentFormMultiSelectDropdown: React.FC<AgentFormMultiSelectDropdownProps> = props => {
  const {
    control,
    errors,
    name,
    isEditDisabled,
    styles,
    inputLabel,
    placeholder,
    options,
    validationMessage,
    showRequiredIcon = false
  } = props;

  return (
    <>
      <div className={styles.textContainer}>
        <Typography variant="p4" color="var(--navi-color-gray-c2)">
          {inputLabel}
        </Typography>
        {showRequiredIcon ? <RequiredIcon /> : null}
      </div>
      <Controller
        control={control}
        name={name}
        rules={{
          validate: value => {
            if (showRequiredIcon) {
              return Array.isArray(value) && value.length > 0 ? true : false;
            }
            return true;
          }
        }}
        render={({ field: { onChange, value } }) => (
          <Dropdown
            placeholder={placeholder}
            placeholderColor={'var(--navi-color-gray-c3)'}
            showSolidArrow={true}
            arrowIconWidth={9}
            options={options}
            onSelectionChange={onChange}
            multiSelect={true}
            selectedValue={value as unknown as string}
            containerClasses={styles.dropdownContainer}
            disabled={isEditDisabled}
            error={errors && errors[name] && errors[name].message}
            showEllipsisTooltip={true}
            pickerContainerClasses={'max-h-[266px]'}
            showTextCursorOnDisabled={true}
            tabIndexEnabled={true}
          />
        )}
      />
      {errors && errors[name] && validationMessage && (
        <div className={styles.errorContainer}>
          <ErrorIconOutline />
          <Typography variant="p4" className={styles.errorText}>
            {validationMessage}
          </Typography>
        </div>
      )}
    </>
  );
};

export default AgentFormMultiSelectDropdown;
